<template>
	<div id="printDiv" class="printDiv" style="font-size: 15px;">
		<div class="row-me center-all title">
			<span style="font-size: 25px;">库存出库单</span>
		</div>
		<div style="margin-top: 20px;">
			<div class="table-print-border" style="font-size: 16px;">
				<div class="row-me">
					<div class="table-print-header">单据编号</div>
					<div class="table-print-header">药品名称</div>
					<div class="table-print-header">供应商</div>
					<div class="table-print-header">生产商</div>
					<div class="table-print-header">规格</div>
					<div class="table-print-header">单位</div>
					<div class="table-print-header">数量</div>
					<div class="table-print-header">单价</div>
					<div class="table-print-header">总价</div>
					<div class="table-print-header">批号</div>
					<div class="table-print-header">有效期</div>
					<div class="table-print-header">类型</div>
					<div class="table-print-header">出库时间</div>
					<div class="table-print-header">生产日期</div>
					<div class="table-print-header">产地</div>
				</div>
				<div class="row-me" v-for="(item,index) in tableData" :key="index">
					<div class="table-print-cell">{{item.receiptNo}}</div>
					<div class="table-print-cell">{{item.drugName}}</div>
					<div class="table-print-cell">{{item.supplierName}}</div>
					<div class="table-print-cell">{{item.producerName}}</div>
					<div class="table-print-cell">{{item.spec}}</div>
					<div class="table-print-cell">{{item.unitName}}</div>
					<div class="table-print-cell">{{item.nums}}</div>
					<div class="table-print-cell">{{item.costPrice}}</div>
					<div class="table-print-cell">{{item.totalPrice}}</div>
					<div class="table-print-cell">{{item.batchNo}}</div>
					<div class="table-print-cell">{{item.validityTime}}</div>
					<div class="table-print-cell">{{item.typeName}}</div>
					<div class="table-print-cell">{{item.createTime}}</div>
					<div class="table-print-cell">{{item.produceTime}}</div>
					<div class="table-print-cell">{{item.productAddress}}</div>
				</div>
			</div>
		</div>
		<button v-show="false" id="btnPrint" v-print="'#printDiv'"></button>
	</div>
</template>

<script>
	import print from 'print-js'
	export default {
		components: {

		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {

			}
		},
		// 侦听器
		watch: {

		},
		// 计算属性
		computed: {

		},
		// html加载完成之前
		created() {

		},
		// html加载完成后执行。
		mounted() {

		},
		// 事件方法执行
		methods: {
			startPrint() {
				this.$nextTick(() => {
					document.getElementById("btnPrint").click();
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	/*去除页眉页脚*/
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 3mm;
		/* this affects the margin in the printer settings */
	}

	html {
		background-color: #FFFFFF;
		margin: 0;
		/* this affects the margin on the html before sending to printer */
	}

	body {
		border: solid 1px blue;
		margin: 10mm 15mm 10mm 15mm;
		/* margin you want for the content */
	}

	.printDiv {
		padding: 10px;

		.title {
			margin-top: 20px;
		}
	}
</style>
